import { useEffect, useState } from "react";
import { numberFormatter } from "../utils/utils";
import { MIN_PERCENTAGE_TO_SHOW } from "../utils/const";

const withPercentageBlock = (Component: React.ComponentType<any>) => {
  return ({ performance, ...props }: { performance: number }) => {
    const [averageToFormat, setAverageToFormat] = useState(
      performance >= MIN_PERCENTAGE_TO_SHOW || performance <= -MIN_PERCENTAGE_TO_SHOW
        ? performance
        : 0,
    );

    const [value, setValue] = useState(
      numberFormatter.format(Number(performance.toFixed(2))) == "0"
        ? "$0.00"
        : `$${(+numberFormatter.format(Number(performance.toFixed(2)))).toFixed(2)}`.replace(
            "$-",
            "$",
          ),
    );

    const [arrowDirection, setArrowDirection] = useState(
      averageToFormat !== 0 ? (performance < 0 ? "down" : "up") : "none",
    );

    useEffect(() => {
      const averageToFormat =
        performance >= MIN_PERCENTAGE_TO_SHOW || performance <= -MIN_PERCENTAGE_TO_SHOW
          ? performance
          : 0;
      const unFixedValue = numberFormatter.format(Number(performance.toFixed(2)));

      setAverageToFormat(averageToFormat);
      setValue(
        numberFormatter.format(Number(performance.toFixed(2))) == "0"
          ? "$0.00"
          : `$${(+numberFormatter.format(Number(performance.toFixed(2)))).toFixed(2)}`.replace(
              "$-",
              "$",
            ),
      );
      setArrowDirection(averageToFormat !== 0 ? (performance < 0 ? "down" : "up") : "none");
    }, [performance]);

    return (
      <Component
        averageToFormat={averageToFormat}
        value={value}
        arrowDirection={arrowDirection}
        performance={performance}
        {...props}
      />
    );
  };
};

export default withPercentageBlock;
